unit BaseListType;
{

/* Not needed. */

/* Initial. */

}
interface

uses
  BaseType;

type
  TBaseListType = array of TBaseType;

implementation

end.
